import React, { useEffect, useState, useRef } from "react";
import moment from "moment-timezone";
import Form from "react-bootstrap/Form";
import Header from "../../components/header/Header";
import PageHeading from "../../components/pageHeading/PageHeading";
import Footer from "../../components/footer/Footer";
import "./availabilty.scss";
import { BackIcon } from "../../components/Icons";
import { Button, Col, Row } from "react-bootstrap";
import WeeklyCalendar from "./WeeklyCalendar";
import { setLoader } from "../../slice/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  fetchProviderAvailability,
  findNonTruckingSavedAddress,
} from "../../services/auth.service";

import Cancelations from "../../modals/cancelations/Cancelations";
import { useJsApiLoader, Autocomplete } from "@react-google-maps/api";
import {
  GOOGLE_MAPS_API_KEY,
  toast_error,
  toast_warning,
} from "../../config/Constant";
import NonTruckingSavedAddress from "../../modals/savedAddress/NonTruckingSavedAddress";
import { toast } from "react-toastify";
import { selectUser } from "../../slice/authSlice";
import VoiceNoteRecorder from "../VoiceNoteRecorder/VoiceNoteRecorder";
const initialPrompts = [
  "Include keys",
  "Specify location information",
  "List specific tasks",
  "Mention any dogs",
  "Note any allergies",
];

const Availabilty = () => {
  const libraries = ["places"]; // Required for Places API

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries,
  });
  const startRef = useRef();

  const dispatch = useDispatch();
  const location = useLocation();
  const [saveNonTruckingAddress, setsaveNonTruckingAddress] = useState(false);
  const [providerSlots, setProvideSlots] = useState({});
  const [selectedTime, setSelectedTime] = useState("");

  const [jobDetail, setJobDetail] = useState("");

  const [policyChecked, setPolicyChecked] = useState(false);
  const [policyModal, setPolicyModal] = useState(false);
  const [saveAddressModal, setSaveAddressModal] = useState(false); // Added state for save address
  const [selectedDay, setSelectedDay] = useState(new Date());
  const navigate = useNavigate();
  const [locationName, setLocationName] = useState("");
  const [voiceNote, setVoiceNote] = useState(null);

  let policyText = location.state?.policyText;
  const [savedAddressList, setSavedAddressList] = useState([]);

  const user = useSelector(selectUser);
  let userId = user.id;

  const handlePlaceChangedStart = () => {
    if (startRef.current) {
      const place = startRef.current.getPlace();

      if (place) {
        const address = place.formatted_address;

        setLocationName(address);
      }
    }
  };

  const handleInputChange = (event) => {
    setLocationName(event.target.value);
  };

  const providerAvailability = async (date) => {
    const selectedDate = moment(date)
      .startOf("day")
      .format("YYYY-MM-DDTHH:mm:ss");

    let payload = {
      date: selectedDate,
      providerId: location.state?.providerId,
      timezoneOffset: -180,
    };
    await dispatch(setLoader(true));
    try {
      const response = await fetchProviderAvailability(payload);
      await dispatch(setLoader(false));
      if (response.status) {
        setProvideSlots(response?.data);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const today = moment().startOf("day").toISOString();
    providerAvailability(today);
  }, [location.state?.providerId]);

  function addTimeAndFormatISO(date, time) {
    const momentDate = moment(date);
    const year = momentDate.year();
    const month = momentDate.month();
    const day = momentDate.date();

    const combinedDateTime = moment.tz(
      `${year}-${month + 1}-${day} ${time}`,
      "YYYY-MM-DD HH:mm",
      "Atlantic/Bermuda"
    );

    return combinedDateTime.format();
  }

  const handleDetails = (e) => {
    setJobDetail(e.target.value);
  };

  const handleSubmit = async () => {
    if (checkDisable()) {
      return;
    }

    // Only show error if BOTH are missing
    if (!jobDetail && !voiceNote) {
      toast.error(
        "Please enter the job details or record a voice note.",
        toast_error
      );
      return;
    }

    let payload = {
      providerId: location.state?.providerId,
      serviceId: location.state?.serviceId,
      serviceName: location.state?.serviceName,
      jobType: location.state?.jobType,
      unitPrice: location.state?.unitPrice,
      durationExpected: null,
      jobDetail: jobDetail,
      userJobLocation: locationName, // Include job location in the payload
      startTime: addTimeAndFormatISO(selectedDay, selectedTime),
      saveNonTruckingAddress: saveNonTruckingAddress,
      voiceNote,
    };

    navigate("/consumer/job/checkout", { state: { payload: payload } });
  };

  const checkDisable = () => {
    if (
      !location.state?.providerId ||
      !location.state?.serviceId ||
      !location.state?.serviceName ||
      !location.state?.jobType ||
      !location.state?.unitPrice ||
      // !jobDetail ||
      !locationName ||
      !selectedTime ||
      !policyChecked
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleCheck = () => {
    if (!policyChecked) {
      setPolicyModal(true);
    }
    setPolicyChecked(false);
  };

  const getSavedAddress = async () => {
    await dispatch(setLoader(true));

    try {
      let payload = {
        personId: userId,
        type: "NonTruckingAddress",
      };

      const response = await findNonTruckingSavedAddress(payload);
      await dispatch(setLoader(false));
      if (response.data.status) {
        setSavedAddressList(response.data.data);
        if (response.data.data?.length > 0) {
          setSaveAddressModal(true);
        } else {
          toast.warning("No saved address found", toast_warning);
        }
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  return (
    <>
      <Header />
      <PageHeading title="Booking Calendar" />
      <div className="main-container">
        <div className="container-wrap">
          <div className="availabilty-wrapper">
            <div className="back-wrapper" onClick={() => navigate(-1)}>
              <div className="back-icon">
                <BackIcon />
              </div>
              <div className="back-title">Booking Calendar</div>
            </div>

            <div className="box-wrapper time-slot-wrapper">
              <WeeklyCalendar
                setSelectedDay={setSelectedDay}
                selectTime={(e) => setSelectedTime(e)}
                selectedTime={selectedTime}
                fetchSlots={(e) => providerAvailability(e)}
                slots={providerSlots}
              />
            </div>
            <div className="box-wrapper expected-time-wrapper">
              <Row className="g-4">
                <Col md={7}>
                  <Form.Group controlId="jobDetails">
                    <Form.Label>Describe job details</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={10}
                      placeholder="Describe job details"
                      value={jobDetail}
                      onChange={handleDetails}
                    />
                  </Form.Group>
                </Col>

                <Col md={7}>
                  <Form.Label>Optional: Add Voice Note</Form.Label>
                  <VoiceNoteRecorder
                    onAudioRecorded={(file) => setVoiceNote(file)}
                  />
                </Col>

                {/* Job Location Field with Google Places Autocomplete */}
                <Col md={7}>
                  <Form.Group controlId="jobLocation">
                    <Form.Label>Job Location</Form.Label>
                    {isLoaded ? (
                      <Autocomplete
                        onLoad={(ref) => (startRef.current = ref)}
                        onPlaceChanged={handlePlaceChangedStart}
                        options={{
                          componentRestrictions: { country: "BM" }, // Restrict to Bermuda
                        }}
                      >
                        <Form.Control
                          className="location"
                          type="text"
                          placeholder="Search"
                          value={locationName}
                          onChange={handleInputChange}
                        />
                      </Autocomplete>
                    ) : null}

                    {/* Add a button to clear the location */}
                  </Form.Group>
                </Col>

                <Form.Check
                  type="checkbox"
                  checked={saveNonTruckingAddress}
                  onChange={(e) => setsaveNonTruckingAddress(e.target.checked)}
                  label="Save sender details"
                />

                <a
                  href="javascript:void(0)"
                  className="link-underline-primary"
                  onClick={() => getSavedAddress()}
                >
                  Get from saved address
                </a>

                <Col xs={12}>
                  <Form.Check
                    inline
                    type="checkbox"
                    id=""
                    label="Review Cancelation Policy"
                    value={policyChecked}
                    checked={policyChecked}
                    onClick={() => handleCheck()}
                  />
                </Col>
                <Col xs={12}>
                  <Button
                    variant="primary"
                    disabled={checkDisable()}
                    onClick={() => handleSubmit()}
                  >
                    Next
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      {saveAddressModal ? (
        <NonTruckingSavedAddress
          saveAddressModal={saveAddressModal}
          setSaveAddressModal={setSaveAddressModal}
          savedAddressList={savedAddressList}
          setLocationName={setLocationName}
        />
      ) : null}

      {policyModal ? (
        <Cancelations
          policyModal={policyModal}
          setPolicyChecked={setPolicyChecked}
          setPolicyModal={setPolicyModal}
          policyText={policyText}
        />
      ) : null}
    </>
  );
};

export default Availabilty;
